import React, { Component } from 'react';
import Scanner from './Scanner';
import { Button, Modal } from 'react-bootstrap';
import "./styles.css"

class BarcodeScan extends Component {
    constructor(props) {
        super(props);
        this.state = {
            results: [],
            scanCode: '',
            modal: false,
            scanSuccess: false
        };
        this._onDetected = this._onDetected.bind(this);
        this._toggle = this._toggle.bind(this);
    }

    render() {
        return (
            <div>
                <Button variant="info" onClick={this._toggle}>
                    ここをタッチしてスキャンを続ける
                </Button>
                <Modal show={this.state.modal} onHide={this._toggle}>
                    <Modal.Header closeButton="true" />
                    <Modal.Body>
                        <Scanner handleScan={this._onDetected} />
                    </Modal.Body>
                </Modal>
            </div>
        );
    }

    _toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal,
            scanSuccess: false
        }));
    }

    _onDetected(result) {

        const {setBarcode, barcodeReScan, setBarcodeReScan} = this.props;

        this.setState({
            modal: false,
            scanCode: result ? result.codeResult.code : '',
            scanSuccess: result ? true : false,
            results: result
        });

        let newArr = [...barcodeReScan]

        // if(result?.codeResult?.code){

        //     let list = newArr.concat(result.codeResult.code);
        //     setBarcodeReScan(list);
        // }
        // setBarcode(result.codeResult.code);

        if(result && result.codeResult.code.length < 13){
            setBarcode('0000000000000'.slice(0, 13-result.codeResult.code.length)+`${result.codeResult.code}`);

            let list = newArr.concat('0000000000000'.slice(0, 13-result.codeResult.code.length)+`${result.codeResult.code}`);
            setBarcodeReScan(list);
        }else{
            setBarcode(result.codeResult.code.slice(0, 13));

            let list = newArr.concat(result.codeResult.code.slice(0, 13));
            setBarcodeReScan(list);
        }
    }
}

export default BarcodeScan;
